import React, { useEffect, useRef, useState } from "react";

const Typewriter = ({ lines, speed = 32, lineDelay = 240, onDone, skip = false }) => {
  const [shown, setShown] = useState([""]);
  const [done, setDone] = useState(false);
  const skipRef = useRef(skip);
  skipRef.current = skip;

  // Keep latest onDone in a ref so re-renders with a new arrow-fn callback
  // don't retrigger the effect and restart the typewriter (visible bug:
  // letter looping / never completing / lines duplicating).
  const onDoneRef = useRef(onDone);
  onDoneRef.current = onDone;

  useEffect(() => {
    let cancelled = false;
    const finish = () => {
      setShown(lines.slice());
      setDone(true);
      onDoneRef.current && onDoneRef.current();
    };
    const run = async () => {
      const out = [];
      for (let li = 0; li < lines.length; li++) {
        if (cancelled) return;
        if (skipRef.current) { finish(); return; }
        const line = lines[li];
        out.push("");
        if (line === "") {
          setShown([...out]);
          await new Promise((r) => setTimeout(r, lineDelay));
          continue;
        }
        for (let ci = 0; ci < line.length; ci++) {
          if (cancelled) return;
          if (skipRef.current) { finish(); return; }
          out[li] = line.slice(0, ci + 1);
          setShown([...out]);
          await new Promise((r) => setTimeout(r, speed));
        }
        await new Promise((r) => setTimeout(r, lineDelay));
      }
      if (!cancelled) {
        setDone(true);
        onDoneRef.current && onDoneRef.current();
      }
    };
    run();
    return () => { cancelled = true; };
    // Intentionally NOT depending on onDone — see ref above.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lines, speed, lineDelay]);

  return (
    <>
      {shown.map((line, i) =>
        line === "" && lines[i] === ""
          ? <p key={i} className="md-blank" />
          : <p key={i}>{line}{i === shown.length - 1 && !done ? <span className="md-caret">▍</span> : null}</p>
      )}
    </>
  );
};

export default Typewriter;
